// Third-party
import React from 'react';

// Components
import DatesDisclaimer from './DatesDisclaimer';

// Utils
import { getRiskDataAsAtDates } from '../../../../utils/disclaimers/comparison';
import { formatMessage } from '../../../../utils/i18n';
import ComparisonItem from '@/types/comparison-item';

interface Props {
  items: ComparisonItem[];
  showItemNames?: boolean;
}

const BetaDisclaimer = ({ items, showItemNames }: Props) => (
  <DatesDisclaimer
    showItemNames={showItemNames}
    globalPrefix={formatMessage('Disclaimers.Beta')}
    itemPrefix={formatMessage('Disclaimers.EndingOn')}
    itemDates={getRiskDataAsAtDates(items)}
  />
);

export default BetaDisclaimer;
